import type { FaireProductEntity } from "../../entity_types/product";

export const p_3frb37799z: FaireProductEntity = {
  token: "p_3frb37799z",
  type: "product",
  name: "Short Sleeve Tiered Maxi Dress",
  brandToken: "b_3l4cxzzyla",
  brandName: "THML",
  imageUrl:
    "https://cdn.faire.com/fastly/7b48f8ecdd3f48323869cfb49503145da178c374420008d455e3dda67ffc20d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e654fa2bf34857123ab892a51c53bc538a24e6c1a626567c6afb9335ec33cc91.jpeg",
    "https://cdn.faire.com/fastly/d0a8f09c9494ba73680828acdbe7f6f5def497483914c8c97748e5c2dfdd17e5.jpeg",
    "https://cdn.faire.com/fastly/de2570747ee5822003d152f9672e26e1b18afb70f99116c7254901382ea8ea2a.jpeg",
    "https://cdn.faire.com/fastly/d494cba9470c04b759da07fcb09b0175436909b5e5bfa71249ee539240fc45e7.jpeg",
    "https://cdn.faire.com/fastly/e437bac4afa7a2facffaadee8dffbbc450a03b6f56efb5d830434e923a37174c.jpeg",
    "https://cdn.faire.com/fastly/2161e00ec66cca992d53ca2fb0e98a026fc78fcff481fd530303077e49856648.jpeg",
  ],
  priceDollars: 42.55,
  description:
    'Short Sleeve Tiered Maxi Dress\r\n.\r\n/ Style Measurements for Size S\r\n/ Designed in USA\r\n - Body Length: 49 in\r\n - Bust Width: 39 in\r\n - Sleeve Length: 10 3/4 in\r\n.\r\n/ Model Sizes\r\n - Wearing Size S\r\n - Height 5\' 9", Bust 32", Waist 25 1/2", Hips 36"\r\n.\r\n/ Prepack Contents\r\n - In a Pack of XS(1), S(2), M(2), and L(1) per Color Only\r\n.\r\n/ Fabric Content\r\n - WOVEN / 75% Polyester, 20% Cotton, 5% Nylon',
  tags: [],
  msrpDollars: 85.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:57.812Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
